import { render, staticRenderFns } from "./VacanciesFeedbackFormBlock.vue?vue&type=template&id=c469f24c&scoped=true&"
import script from "./VacanciesFeedbackFormBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesFeedbackFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesFeedbackFormBlock.vue?vue&type=style&index=0&id=c469f24c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469f24c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VacanciesFeedbackForm: require('/var/www/ct-frontend/ct-front-20261029043307/components/vacancies/VacanciesFeedbackForm.vue').default})
